import api from "../../utils/axios";
import { SORTER_ENDPOINTS } from "./endpoints";
import {
	CreateSorterPlanRequest,
	RenameSorterPlanRequest,
	SorterPlanDetail,
	SorterPlanSlotWithZones,
	SorterPlanSummary,
} from "./types";

export const listPlans = async (): Promise<SorterPlanSummary[]> => {
	const response = await api.get<SorterPlanSummary[]>(
		SORTER_ENDPOINTS.listPlans
	);
	return response.data ?? [];
};

export const getPlanDetail = async (
	planId: number
): Promise<SorterPlanDetail> => {
	const response = await api.get<SorterPlanDetail>(
		SORTER_ENDPOINTS.planDetail(planId)
	);
	return response.data;
};

export const getPlanSlots = async (
	planId: number
): Promise<SorterPlanSlotWithZones[]> => {
	const response = await api.get<SorterPlanSlotWithZones[]>(
		SORTER_ENDPOINTS.planSlots(planId)
	);
	return response.data ?? [];
};

export const createPlan = async (
	body: CreateSorterPlanRequest
): Promise<SorterPlanSummary> => {
	const response = await api.post<SorterPlanSummary>(
		SORTER_ENDPOINTS.createPlan,
		body
	);
	return response.data;
};

export const renamePlan = async (
	planId: number,
	body: RenameSorterPlanRequest
): Promise<void> => {
	await api.put(SORTER_ENDPOINTS.plan(planId), body);
};

export const deletePlan = async (planId: number): Promise<void> => {
	await api.delete(SORTER_ENDPOINTS.plan(planId));
};

export const activatePlan = async (planId: number): Promise<void> => {
	await api.put(SORTER_ENDPOINTS.activatePlan(planId));
};
